import { Component, Input } from '@angular/core';
import { EJobType } from '../job-type.enum';
import { IFilterColumn } from '../IFilterColumn';
import { IJob } from '../IJob';

@Component({
    selector: 'job-schedules',
    templateUrl: 'job-schedules.component.html',
    styleUrls: ['job-schedules.component.scss']
})
export class JobSchedulesComponent {
    @Input() currentJob: IJob;
    @Input() jobType: EJobType;

    public columns: Array<IFilterColumn>;

    private _defaultcolumns: Array<IFilterColumn> = [
      { key: 'schName', value: 'JOBS.COLUMN_NAME', visible: true,  type: 'text' },
      { key: 'schRecurring', value: 'JOBS.COLUMN_RECURRING', readonly: true, visible: true, type: 'boolean' },
      { key: 'schOccurs', value: 'JOBS.COLUMN_OCCURS', visible: true, type: 'text' },
      { key: 'idSchType', value: 'JOBS.COLUMN_TYPE', visible: true, type: 'type' },
      { key: 'schStartDate', value: 'JOBS.COLUMN_START_DATE', visible: true, type: 'date' },
      { key: 'nextRuntime', value: 'JOBS.COLUMN_NEXT_RUN_TIME', visible: true, type: 'date' }
    ];

    private _userJobColumns: Array<IFilterColumn> = [
      { key: 'name', value: 'JOBS.COLUMN_NAME', visible: true,  type: 'text' },
      { key: 'recurring', value: 'JOBS.COLUMN_RECURRING', readonly: true, visible: true, type: 'boolean' },
      { key: 'recurrence', value: 'JOBS.COLUMN_OCCURS', visible: true, type: 'frequency' },
      { key: 'type', value: 'JOBS.COLUMN_TYPE', visible: true, type: 'frequencyType' },
      { key: 'startDate', value: 'JOBS.COLUMN_START_DATE', visible: true, type: 'date' }
    ];

    constructor(){

    }

    ngOnChanges(): void {
      switch (this.jobType) {
        case EJobType.User:
          this.columns = this._userJobColumns;
          break;
        default:
          this.columns = this._defaultcolumns;
          break;
      }
    }

}
